/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { FractionDependencies } from './dependenciesFractionClass.generated';
import { isNegativeDependencies } from './dependenciesIsNegative.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated';
import { createCbrt } from '../../factoriesAny.js';
export var cbrtDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  ComplexDependencies: ComplexDependencies,
  FractionDependencies: FractionDependencies,
  isNegativeDependencies: isNegativeDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  unaryMinusDependencies: unaryMinusDependencies,
  createCbrt: createCbrt
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCbrt.generated.js
// module id = 1500
// module chunks = 0